// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var ViewStack = require("../../common/ViewStack.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRender = require("../../utils/ReactRender.bs.js");
var ClickOutside = require("../../common/ClickOutside.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var MarkupHelpers = require("components/MarkupHelpers");

function SearchComponents$MenuItem$OpenItem(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(MarkupHelpers.ContentBox, {
                    paddingFull: true,
                    hasShadow: true,
                    hasBorder: true,
                    children: Caml_option.some(props.children)
                  }),
              className: "absolute z-20"
            });
}

var OpenItem = {
  make: SearchComponents$MenuItem$OpenItem
};

function SearchComponents$MenuItem(props) {
  var match = React.useState(function () {
        return false;
      });
  var setIsOpen = match[1];
  var isOpen = match[0];
  return JsxRuntime.jsxs(ClickOutside.make, {
              fullSize: false,
              onClickOutside: (function () {
                  setIsOpen(function (param) {
                        return false;
                      });
                }),
              children: [
                JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                      onClick: (function (param) {
                          setIsOpen(function (p) {
                                return !p;
                              });
                        }),
                      size: "small",
                      ariaExpanded: isOpen,
                      id: props.id,
                      children: Caml_option.some(JsxRuntime.jsxs(ViewStack.make, {
                                space: "sm",
                                flexDirection: "row",
                                children: [
                                  JsxRuntime.jsx("span", {
                                        children: props.title
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                              icon: isOpen ? "ArrowUp" : "ArrowDown"
                                            }),
                                        "aria-hidden": true,
                                        className: "flex"
                                      })
                                ]
                              }))
                    }),
                ReactRender.ifTrue(JsxRuntime.jsx(SearchComponents$MenuItem$OpenItem, {
                          children: props.children
                        }), isOpen)
              ]
            });
}

var MenuItem = {
  OpenItem: OpenItem,
  SecondaryButton: undefined,
  make: SearchComponents$MenuItem
};

exports.MenuItem = MenuItem;
/* react Not a pure module */
